<cpd-dialog-container dialogTitle=" How We Use AI" [isCloseIconVisible]="true">
  <section class="grid-y gap-2">
    <h2>How CPD Uses Generative AI</h2>
    <div class="update-date">
      <fa-icon [icon]="['far', 'clock']"></fa-icon>
      <span>Updated October 10, 2025</span>
    </div>

    <p>
      Generative AI (GenAI) is a rapidly advancing technology with powerful
      benefits, but it is still evolving.
    </p>

    <p>
      Within Career Path DECIDE, we use GenAI to enhance your career and
      education planning experience. It helps our AI Virtual Advisor (Via)
      interpret your profile, uncover insights, suggest career or education
      options, and guide you through next steps. We <strong>never</strong> use
      GenAI to replace your personal judgment or make final decisions for you.
    </p>

    <hr class="divider" />

    <h2>What You Should Know</h2>
    <ul>
      <li>
        <strong>Your data is protected.</strong> CPD safeguards user information
        using industry-leading security and privacy practices, and follows
        responsible AI principles in every part of our platform.
      </li>

      <li>
        <strong>You’re always in control.</strong> Our AI can suggest paths or
        generate guidance, but only you decide what’s right for your career
        journey.
      </li>

      <li>
        <strong>Some features are in beta.</strong> New AI-powered tools may be
        available at no extra cost during early release. Features, terms, and
        access may change without notice.
      </li>

      <li>
        <strong>Human help is available.</strong> If you have questions or
        something doesn’t seem right, we encourage you to connect with your
        counselor or another trusted advisor for additional help.
      </li>
    </ul>

    <hr class="divider" />

    <h2>Remember</h2>
    <ul>
      <li>
        You know your goals and circumstances best. Don’t make important career,
        education, or financial decisions based solely on AI-generated guidance.
      </li>

      <li>
        Our AI Virtual Advisor doesn’t provide legal, financial, or tax advice.
      </li>

      <li>Your feedback helps us improve CPD, so please tell us what you think!</li>
    </ul>
  </section>
</cpd-dialog-container>
